import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/plat/admin/giftGroup/';

function baseApi() {

    function deleteData(data) {
        return Post(baseUrl + 'deleteGiftGroup', data);
    }
    function manageGroupRelationship(data) {
        return Post(baseUrl + 'manageGroupRelationship', data);
    }
    function update(data) {
        return Post(baseUrl + 'updateGiftGroup', data);
    }
    function query(data) {
        return Post(baseUrl + 'queryGiftGroup', data);
    }

    return {
        deleteData,
        manageGroupRelationship,
        update,
        query
    };
}

export const giftCodeGroupApi = baseApi();
